export default {
  slug: "gum-treatment-in-guwahati",
  title: "Gum Treatments and Surgeries in Guwahati",
  subtitle: "Gum Treatments and Surgeries- Strong dental foundations start here",

  heroImage:
    "/dental-services/best-dental-treatment-in-guwahati.webp",

  sections: [
    {
      type: "text",
      heading: "Gum Treatments at Magnum Dental Clinic, Guwahati",
      content: `
Healthy gums are the foundation of a healthy smile. Gum disease (periodontal disease) is a common but serious condition that can lead to tooth loss, bad breath, bleeding gums, and jawbone damage if left untreated.

At **Magnum Dental Clinic**, we offer advanced gum treatments and periodontal surgeries to restore gum health, control infection, and improve both function and appearance. Our treatments are safe, effective, and performed with a strong focus on patient comfort.
      `,
    },
 {
      type: "image",
      images: [
        "/dental-services/gum-treatment/gum-treatment-in-guwahati.webp",
        "/dental-services/gum-treatment/gum-swelling-treatment-in-guwahati.webp",
        "/dental-services/gum-treatment/gums-pain-treatment-in-guwahati.webp",
      ],
      caption: "Images are for illustrative purposes only",
    },
    {
      type: "text",
      heading: "When Do You Need Gum Treatment?",
      content: `
You may need gum treatment if you experience:

✔ Bleeding gums while brushing or flossing  
✔ Swollen, red, or tender gums  
✔ Persistent bad breath  
✔ Gum recession or teeth appearing longer  
✔ Loose teeth  
✔ Pain while chewing  
✔ Pus discharge from gums  

Early treatment prevents complications and helps save natural teeth.
      `,
    },

    {
      type: "text",
      heading: "Our Gum Treatments & Surgical Services",
      content: `
We provide a wide range of non-surgical and surgical periodontal treatments, depending on the severity of gum disease.

✔ Professional Teeth Cleaning (Scaling & Root Planing)  
Deep cleaning removes plaque, calculus, and bacteria from below the gum line, helping gums heal and reattach to the teeth.

✔ Gingivectomy  
Gingivectomy is the surgical removal of excess or infected gum tissue. It helps:  
Eliminate deep gum pockets  
Control gum infection  
Improve gum shape and hygiene  
This procedure is commonly done for moderate to advanced gum disease.

✔ Flap Surgery (Periodontal Surgery)  
Flap surgery is performed when deep gum pockets cannot be treated with cleaning alone. The gums are gently lifted to remove infection and then repositioned for better healing and bone support.

✔ Crown Lengthening  
Crown lengthening exposes more of the tooth surface by reshaping excess gum or bone. It is done for:  
Restoring broken or decayed teeth  
Cosmetic smile improvement  
Preparing teeth for crowns

✔ Gingival Depigmentation  
Dark or pigmented gums can affect smile aesthetics. Gingival depigmentation is a cosmetic procedure that safely removes excess melanin, giving gums a lighter, pink appearance.

✔ Gum Recession Coverage (Gum Grafting)  
When gums recede and expose tooth roots, recession coverage procedures help:  
Protect exposed roots  
Reduce tooth sensitivity  
Improve smile aesthetics  
Prevent further damage
      `,
    },

    {
      type: "text",
      heading: "Are Gum Surgeries Painful?",
      content: `
No. Gum treatments and surgeries are performed under local anesthesia, making them comfortable and pain-free. Mild soreness after the procedure is temporary and manageable with medication.

At **Magnum Dental Clinic**, we use modern techniques and gentle care to ensure smooth healing.
      `,
    },

    {
      type: "text",
      heading: "Healing & Aftercare",
      content: `
Most patients experience initial healing within 7–10 days, while complete healing may take a few weeks depending on the procedure.

We provide detailed post-treatment instructions, including:

✔ Oral hygiene guidance  
✔ Diet recommendations  
✔ Medication support  
✔ Follow-up visits
      `,
    },

    {
      type: "text",
      heading: "Why Choose Magnum Dental Clinic for Gum Treatment in Guwahati?",
      content: `
✔ Experienced periodontist  
✔ Advanced surgical techniques  
✔ Strict sterilization protocols  
✔ Comfortable, patient-first approach  
✔ Affordable and transparent pricing  
✔ Personalized gum care plans
      `,
    },
  ],

  faqs: [
    {
      q: "Is gum disease reversible?",
      a: "Early-stage gum disease can be reversed with timely professional treatment and good oral hygiene.",
    },
    {
      q: "Can gum disease cause tooth loss?",
      a: "Yes. Untreated gum disease is one of the leading causes of tooth loss in adults.",
    },
    {
      q: "Will my gums look better after treatment?",
      a: "Yes. Treatments improve gum health, reduce inflammation, and enhance smile appearance.",
    },
  ],

  cta: {
    heading: "Book Gum Treatment & Surgery in Guwahati",
    description: `
Bleeding gums and gum pain should never be ignored. Timely gum treatment can save your teeth and restore your smile.

📍 Location: First Floor, Global Tower, Near Mangalam Grand, Pathar Quarry, VIP Road, Guwahati, Assam

📞 Call at 8638940021 for consultation and pricing details

🦷 Healthy gums. Strong teeth. Confident smiles.
    `,
    buttonText: "Book Gum Treatment Consultation",
    link: "/book-appointment-dental-clinic-guwahati",
  },
};
